import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { User } from '../models/user_detail';

@Injectable({
  providedIn: 'root',
})
export class SignupWizardServerService {
  user_url = {
    registerUser: environment.URL + 'customer/register', //1st
    verifyOtp: environment.URL + 'customer/verify', //2nd
    resendOtp: environment.URL + 'customer/resend-otp',
    getPlans: environment.URL + 'public/plan/retrieve/all', //3rd
    createOrder: environment.URL + 'kreta/order/create',
    fetchOrderDetails: environment.URL + 'kreta/order/get',
    subscribe: environment.URL + 'kreta/subscription/subscribe',
    getSubscriptionDetails: environment.URL + 'public/subscription/details',
    markPlanAsSelected: environment.URL + 'public/customer/plan-selected', //4th
    markCheckoutRoute: environment.URL + 'public/customer/checkout-route',
    getNewSubscriptionPlans:
      environment.URL + 'public/plan/retrieve/all/newSubscription', //3rd
    getUpgradePlans: environment.URL + 'public/plan/retrieve/all/upgradeOnly',
    startTrial: environment.URL + 'kreta/customer/trial/start',
    triggerLeadOtp: environment.URL + 'public/leads/trigger-otp',
    getCustomPlans: environment.URL + 'public/plan/custom/get',
  };

  constructor(private http: HttpClient) {}

  /**
   * Registers a user with the provided details
   * @param userDetails - The user details to be registered
   * @returns {Observable<any>} - Observable containing the registration response
   */
  registerUser(userDetails: User): Observable<any> {
    return this.http.post(this.user_url.registerUser, userDetails);
  }

  /**
   * Verifies the OTP entered by the user
   * @param otpData - The OTP verification data
   * @returns {Observable<any>} - Observable containing the OTP verification response
   */
  verifyOtp(otpData: any): Observable<any> {
    return this.http.post(this.user_url.verifyOtp, otpData);
  }

  /**
   * Resends the OTP to the user's email
   * @param email - The user's email address
   * @returns {Observable<any>} - Observable containing the response of OTP resend
   */
  resendOtp(email: string): Observable<any> {
    return this.http.post(this.user_url.resendOtp, { email });
  }

  /**
   * Retrieves all available subscription plans
   * @returns {Observable<any>} - Observable containing the available plans
   */
  // getPlans(): Observable<any> {
  //   return this.http.get(this.user_url.getPlans);
  // }
  getPlans(): Observable<any> {
    return this.http.get(this.user_url.getNewSubscriptionPlans);
  }

  /**
   * Creates a new order with Cashfree
   * @param orderDetails - The order details
   * @returns {Observable<any>} - Observable containing the Cashfree order response
   */
  createOrder(orderDetails: any): Observable<any> {
    return this.http.post(this.user_url.createOrder, orderDetails);
  }

  createSubscribe(subDetails: any): Observable<any> {
    return this.http.post(this.user_url.subscribe, subDetails);
  }

  // Method to fetch order details by orderId
  getOrderById(orderId: number): Observable<any> {
    return this.http.get<any>(`${this.user_url.fetchOrderDetails}/${orderId}`);
  }

  // flag of user had selected/interested plan
  markPlanAsSelected(userId: string): Observable<any> {
    return this.http.post(`${this.user_url.markPlanAsSelected}/${userId}`, {});
  }

  /**
   * Records that the customer took the paid fork at the Get Started screen.
   * Fire-and-forget from the wizard: the admin Leads ladder uses it to tell
   * "abandoned at Select Plan" apart from "abandoned at Get Started".
   */
  markCheckoutRoute(userId: string): Observable<any> {
    return this.http.post(`${this.user_url.markCheckoutRoute}/${userId}`, {});
  }

  /**
   * Starts the card-less 30-day free trial. This is what provisions the tenant
   * on the trial branch — nothing exists until the customer presses the button.
   * The caller is taken from the session token, so no id is sent in the body.
   * @returns {Observable<any>} - { trialStarted, tenantUrl, tenantName, trialDays }
   */
  startTrial(): Observable<any> {
    return this.http.post(this.user_url.startTrial, {});
  }

  // Fetch subscription details. An optional failureReason (Cashfree's cf_message
  // from the return URL) is forwarded so the backend records the exact cause on
  // the lead + failure email.
  getSubscriptionDetails(
    dsSubscriptionId: string,
    failureReason: string | null = null
  ): Observable<any> {
    let url = `${this.user_url.getSubscriptionDetails}/${dsSubscriptionId}`;
    if (failureReason) {
      url += `?failureReason=${encodeURIComponent(failureReason)}`;
    }
    return this.http.get<any>(url);
  }

  getUpgradePlans(currentPlanId: any): Observable<any> {
    return this.http.get(`${this.user_url.getUpgradePlans}/${currentPlanId}`);
  }

  triggerOtpForLead(userId: string): Observable<any> {
    return this.http.post(`${this.user_url.triggerLeadOtp}/${userId}`, {});
  }

  getCustomPlans(planId: any): Observable<any> {
    return this.http.get(`${this.user_url.getCustomPlans}/${planId}`);
  }
}
